export class WizardStep {
    constructor(public label: string,
                public icon: JSX.Element,
                public description: string | JSX.Element,
                public optional: boolean | (() => boolean),
                public renderStep: () => JSX.Element,
                public canProceedToNextStep: () => boolean) {
    }
}